// extracted by mini-css-extract-plugin
module.exports = {"search-filter":"search-filter_search-filter__8ce3U"};